import * as React from 'react';
import { useTranslation } from 'react-i18next';
import b_ from 'b_';
import { Helmet } from 'react-helmet';
import NotFound from 'shared/components/NotFound';
import { StockTopCard } from 'components/StockTopCard';
import Content from './components/Content';
import { SubmitForm } from './components/SubmitForm';
import { useProduct } from './hooks';

import './index.scss';

export interface Props {
  id: number;
}

const b = b_.with('stock-landing');

export const StockLanding: React.FC<Props> = ({ id }) => {
  const { t } = useTranslation();

  const { loading, product } = useProduct(id);

  if (loading) {
    return null;
  }

  if (!product) {
    return <NotFound />;
  }

  return (
    <div className={b()}>
      <Helmet>
        <title>{t('Invest in {{name}}', { name: product.title })} | United Traders</title>
        <meta name="description" content={product.description} />
      </Helmet>
      <div className={b('top-card')}>
        <StockTopCard product={product} />
      </div>
      <Content description={product.description} />
      <SubmitForm product={product} />
    </div>
  );
};
